var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportDocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#4FB1EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8495 18.5999V9.31224L12.799 11.2956L11.2 9.6424L15.2 5.77335L15.9995 5L16.799 5.77335L20.799 9.6424L19.2 11.2956L17.1495 9.31224V18.5999H14.8495ZM8.14961 15.5999C8.14961 15.1304 8.53017 14.7499 8.99961 14.7499H10.9996V12.4499H8.99961C7.25991 12.4499 5.84961 13.8602 5.84961 15.5999V21.5999C5.84961 23.3396 7.25991 24.7499 8.99961 24.7499H22.9996C24.7393 24.7499 26.1496 23.3396 26.1496 21.5999V15.5999C26.1496 13.8602 24.7393 12.4499 22.9996 12.4499H20.9996V14.7499H22.9996C23.4691 14.7499 23.8496 15.1304 23.8496 15.5999V21.5999C23.8496 22.0693 23.4691 22.4499 22.9996 22.4499H8.99961C8.53017 22.4499 8.14961 22.0693 8.14961 21.5999V15.5999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportDocumentation);
export default __webpack_public_path__ + "static/media/importDocumentation.dd918a1f.svg";
export { ForwardRef as ReactComponent };